import { render } from "./EditCalendar.vue?vue&type=template&id=137f90c8"
import script from "./EditCalendar.vue?vue&type=script&lang=js"
export * from "./EditCalendar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__